export const STATUS_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_ACCEPTABLE: 488,
  INTERNAL_ERROR: 500,
  NOT_FOUND: 404,
  NETWORKERROR: 0,
  RATE_LIMIT: 429,
  BAD_REQUEST: 400
};
export const DEBOUNCE_TIME = 300;